import React from 'react';
import PropTypes from 'prop-types';
import { StyledLayout } from './styled';

const Layout = ({ children }) => {
    return (
        <StyledLayout>
            {children}
        </StyledLayout>
    );
};

Layout.propTypes = {
    children: PropTypes.node
};

export default React.memo(Layout);
